import { render, staticRenderFns } from "./LobbySettings.vue?vue&type=template&id=b45ccc42&scoped=true"
import script from "./LobbySettings.vue?vue&type=script&lang=js"
export * from "./LobbySettings.vue?vue&type=script&lang=js"
import style0 from "./LobbySettings.vue?vue&type=style&index=0&id=b45ccc42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45ccc42",
  null
  
)

export default component.exports